import { render, staticRenderFns } from "./wholesale-cart-item.vue?vue&type=template&id=446336d7&scoped=true"
import script from "./wholesale-cart-item.vue?vue&type=script&lang=js"
export * from "./wholesale-cart-item.vue?vue&type=script&lang=js"
import style0 from "./wholesale-cart-item.vue?vue&type=style&index=0&id=446336d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446336d7",
  null
  
)

export default component.exports